import { useContext } from 'react';
import OrganizationContext from './organization-context';

const useOrganization = () => useContext(OrganizationContext);

export default useOrganization;